import { useState, useEffect, useContext } from 'react';
import { AppContext } from './context'
import { baseUrl } from './delcare'

const GlobalStyles = () => {

    const {
        mode,
        hh,
        ww, setWw,
        getSrollHeight,
        sliderRef
    } = useContext(AppContext)

    const [h, sH] = useState(null)

    const adjustW = (windowWidth) => {
        setWw(windowWidth)
    }

    const adjustH = () => {
        let scrollHeight = document.documentElement.scrollHeight
        let clientHeight = document.documentElement.clientHeight
        let newH = scrollHeight > clientHeight ? scrollHeight : clientHeight;
        sH(newH)
    }

    useEffect(() => {
        const handleResize = () => {
            getSrollHeight(window.innerHeight)
            adjustW(window.innerWidth)
        }
        adjustW(window.innerWidth)
        adjustH()
        getSrollHeight(window.innerHeight)
        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [])

    useEffect(() => {
        adjustH()
    }, [mode])

    useEffect(() => {
        const slider = sliderRef.current
        if (!slider) return

        const handleInput = function () {
            const ratio = (this.value - this.min) / (this.max - this.min) * 100;
            this.style.background = `linear-gradient(90deg, #650260 ${ratio}%, lightgray ${ratio}%)`;
        }

        slider.addEventListener("input", handleInput)
        return () => slider.removeEventListener("input", handleInput)
    }, [sliderRef.current])

    return (
        <style jsx="true">
            {`
            .poppins {
                font-family: "Poppins", sans-serif;
            }
            .entity-table tr, .entity-table td, .entity-table th, .entity-table {
                border: 1px solid black;
                border-collapse: collapse;
                padding: 3px;
            }
            .login-bg-2 {
                background-image: url('/src/bispoke_brandmark_white.png'), url('/src/bispoke_brandmark_white_2.png');
                background-position: right bottom, left top;
                background-repeat: no-repeat, no-repeat;
                background-size: 300px;
                background-attachment: fixed;
            }
            .login-bg {
                height: ${h}px;
                background-image: url('/src/bispoke_brandmark_white.png'), url('/src/bispoke_brandmark_white_2.png');
                background-position: right bottom, left top;
                background-repeat: no-repeat, no-repeat;
                background-size: 300px;
            }
            .container1 {
                padding: ${ww < 400 ? "20px 0px" : "20px 20px"};
                border-radius: 15px;
                background-color: white;
            }
            .container2 {
                border-radius: 15px;
                background-color: white;
                padding: 20px 0px;
            }
            .login-container {
                padding: 25px 0px;
                border-radius: 25px;
                background-color: white;
            }
            .bispoke-logo {
                background-image: url(${baseUrl}/src/bispoke_logo_black_gradient.png);
                height: 70px;
                width: 200px;
                background-size: 100%;
                background-repeat: no-repeat;
            }
            .gradiant-h {
                background-image: linear-gradient(to right, #CB3974, #FF9933);
            }
            .input1 {
                background-color: #F8F8F8;
                border-radius: 50px;
                padding: 10px 15px;
            }
            .input1 input, .input1 select {
                border: none;
                background-color: #F8F8F8;
                width: 100%;
            }
            .input3 {
                border-radius: 25px;
                border: 1px solid #650260;
                padding: 0px 15px;
            }
            .input3 input {
                border: none;
                background-color: #F8F8F8;
            }
            .button1 {
                height: 45px;
                width: 100%;
                background-color: #650260;
                border-radius: 25px;
            }
            .button2 {
                height: 40px;
                width: 100%;
                cursor: "pointer";
                border: 1px solid white;
                border-radius: 25px;
            }
            .button3 {
                border: 1px solid #650260;
                border-radius: 25px;
                cursor: "pointer";
                color: #650260;
            }
            .navbar-sidebar {
                width: 250px;
                background-image: linear-gradient(to bottom, #CB3974, #FF9933);
                height: ${hh}px;
            }
            .off-icon {
                width: 35px;
                height: 35px;
                background: rgba(255, 255, 255, .2);
            }
            .slider, .slider:hover {
                appearance: none;
                border-radius: 9999px;
                transition: opacity .2s;
                background: linear-gradient(90deg, #650260 0%, lightgray 0%);
                height: 12px;
            }
            .slider::-webkit-slider-thumb {
                appearance: none;
                width: 24px;
                height: 24px;
                border-radius: 9999px;
                background: #650260;
            }
            .slider::-webkit-slider-thumb:hover {
                appearance: none;
                width: 24px;
                height: 24px;
                border-radius: 9999px;
                border: 3px solid #650260;
                background: white;
            }
            .brand-table th:first-child {
                border-top-left-radius: 15px;
                border-bottom-left-radius: 15px;
            }
            .brand-table th:last-child {
                border-top-right-radius: 15px;
                border-bottom-right-radius: 15px;
            }
            .brand-table th {
                height: 50px;
                background-color: #650260;
                color: white;
                text-align: center;
                padding: 0px 10px;
            }
            .brand-table {
                width: 100%;
                font-family: poppins;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
            .brand-table td {
                text-align: center;
                height: 50px;
                padding: 0px 10px;
            }
            .brand-table tbody {
                background-color: white;
            }
            .brand-table tbody>tr:first-child>td:first-child {
                border-top-left-radius: 15px;
            }
            .brand-table tbody>tr:first-child>td:last-child {
                border-top-right-radius: 15px;
            }
            .brand-table tbody>tr:last-child>td:first-child {
                border-bottom-left-radius: 15px;
            }
            .brand-table tbody>tr:last-child>td:last-child {
                border-bottom-right-radius: 15px;
            }
            .brand-table tbody>tr:last-child>td {
                border-bottom: 0!important;
            }
            .middle-row-th {
                border-left: 1px solid lightgray;
                border-rigt: 1px solid lightgray;
            }
            .middle-row-td {
                border-left: 1px solid lightgray;
                border-rigt: 1px solid lightgray;
                border-bottom: 1px solid lightgray;
                cursor: pointer;
            }
            .brand-table td:first-child {
                border-bottom: 1px solid lightgray;
            }
            .input-radio {
                accent-color: #650260;
                width: 16px;
                height: 16px;
                border-color: #650260;
            }
            .input-date::-webkit-inner-spin-button,
            .input-date::-webkit-calendar-picker-indicator {
                display: none;
                -webkit-appearance: none;
            }
            .tab-on {
                background-color: #ff9933;
                border-top-left-radius: 8px;
                border-top-right-radius: 8px;
                min-width: 70px;
                color: white;
            }
            .tab-off {
                background-color: none;
                border-top-left-radius: 8px;
                border-top-right-radius: 8px;
                min-width: 70px;
                color: dark;
            }
            .small-btn {
                font-size: 14px;
                color: #650260;
                text-decoration: none;
                border: 1px solid #650260;
                border-radius: 25px;
                padding: 0px 10px;
            }
            `}
        </style>
    )
}

export default GlobalStyles